import { cn } from "../../utils";
import { Checkbox } from "../Checkbox";
import { CheckboxCardProps } from "./types";

export const CheckboxCard = ({
  disabled,
  checkboxPosition,
  className,
  size = "md",
  ...checkboxProps
}: CheckboxCardProps) => {
  const rootClass = cn(
    "flex items-start gap-3 cursor-pointer",
    "border border-neutral-500/10 rounded-xl",
    size === "sm" ? "p-3" : "p-4",
    "hover:outline hover:outline-[1px] hover:outline-neutral-500/10",
    "has-[:focus-visible]:outline has-[:focus-visible]:outline-[1px] has-[:focus-visible]:outline-primary-500 has-[:focus-visible]:border-primary-500",
    "has-[:focus-visible]:hover:outline-primary-500",
    checkboxPosition === "start"
      ? "flex-row"
      : "flex-row-reverse justify-between",
    className,
  );

  return (
    <Checkbox
      disabled={disabled}
      {...checkboxProps}
      className={rootClass}
      size={size}
      isCard
      style={{ outlineOffset: "0px" }}
    />
  );
};
